import React from 'react';
import Typed from 'react-typed';
import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import AccordionOne from '../accordion/AccordionOne';

const mission = () => {
    return (
        <div className="rn-company-mission-are rn-section-gap">
            <div className="container">
                <div className="row row--30">
                    <div className="col-lg-6">
                        <div className="mission-title">
                            <h2 className="title">Compania noastră <br /> {" "}
                                <Typed className="theme-gradient"
                                    strings={[
                                        "Asistență și consultanță",
                                        "Dezvoltare software",
                                        "Testing și optimizare",
                                    ]}
                                    typeSpeed={80}
                                    backSpeed={5}
                                    backDelay={1000}
                                    loop
                                />
                            </h2>
                            <p>Cu ce ne ocupăm și care este domeniul de activitate?</p>

                            <p>Care sunt ariile în care profesăm?</p>

                            <div className="read-more-btn mt--50">
                                <Link className="btn-default btn-icon" to="/about-us">Mai multe despre noi <i className="icon"><FiArrowRight /></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt_md--30 mt_sm--30">
                        <AccordionOne customStyle="" />
                    </div>
                </div>
            </div>                        
        </div>
    )
}
export default mission;
